import React, { useEffect, useState } from 'react';
import { Descriptions, Spin, Alert } from 'antd';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import moment from 'moment';
import { baseUrl } from '../../config/apiConfig';
import tokenStore from '../../stores/TokenStore';


const TransactionDetailPage = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [orderDetails, setOrderDetails] = useState(null);

  useEffect(() => {
    const fetchOrderDetails = async () => {
      try {
        const token = tokenStore.token;
        const response = await axios.post(baseUrl + '/pay/select_pay_info',
          { id },
          { headers: { token: `${token}` } }
        );

        setOrderDetails(response.data.data);
        setLoading(false);
      } catch (err) {
        setError('Failed to load order details');
        setLoading(false);
      }
    };

    fetchOrderDetails();
  }, [id]);

  if (loading) {
    return <Spin tip="Loading..." />;
  }

  if (error) {
    return <Alert message={error} type="error" />;
  }

  const overviewItems = [
    { label: 'Merchant ID', span: 2, children: orderDetails.merchantId },
    { label: 'Order No', span: 2, children: orderDetails.vendorOrderNo },
    { label: 'WeChatPay Order No', span: 2, children: orderDetails.wechatOrderNo },
    { label: 'Time of Application', span: 2, children: moment(orderDetails.timeOfApplication).format('YYYY-MM-DD HH:mm:ss') },
    { label: 'Time of Payment', span: 2, children: orderDetails.timeOfPayment ? moment(orderDetails.timeOfPayment).format('YYYY-MM-DD HH:mm:ss') : 'N/A' },
    { label: 'Amount', span: 2, children: `$${(orderDetails.orderAmount / 100).toFixed(2)} ${orderDetails.currency}` },
    { label: 'Transaction Status', span: 2, children: orderDetails.status },
    { label: 'Type of Currency', span: 2, children: orderDetails.currency },
  ];

  const detailItems = [
    { label: 'APPID', span: 4, children: orderDetails.tmerchant.wxMerchantId },
    { label: 'Transaction Status', span: 4, children: orderDetails.status },
    { label: 'Type of Payment', span: 4, children: orderDetails.type },
    { label: 'Amount Buyer Paid', span: 4, children: `$${(orderDetails.actuallyAmount / 100).toFixed(2)} ${orderDetails.currency}` },
    { label: 'Cash Coupon Amount', span: 4, children: `$${(orderDetails.cashCouponAmount / 100).toFixed(2)}` },
    { label: 'No Cash Coupon Amount', span: 4, children: `$${(orderDetails.noCashCouponAmount / 100).toFixed(2)}` },
    { label: "'Vendor's Data package(attach)", span: 4, children: orderDetails.vendorDataPackage },
    { label: "Product Information", span: 4, children: orderDetails.productInformation }
  ];

  return (
    <>
      <Descriptions
        title="Order Overview"
        bordered
        column={{ xs: 1, sm: 2, md: 3, lg: 3, xl: 4, xxl: 4 }}
        items={overviewItems}
      />
      <Descriptions
        title="Order Details"
        bordered
        column={{ xs: 1, sm: 2, md: 3, lg: 3, xl: 4, xxl: 4 }}
        items={detailItems}
      />
    </>
  );
};
export default TransactionDetailPage;
